"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwitchBaseInput = exports.SwitchBaseContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SwitchBaseInput = _styledComponents["default"].input(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  opacity: 0;\n  cursor: ", ";\n"])), function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? 'default' : 'pointer';
});

exports.SwitchBaseInput = SwitchBaseInput;

var SwitchBaseContainer = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  opacity: ", ";\n  label {\n    display: flex;\n    text-align: left;\n    align-items: center;\n    white-space: normal;\n    color: ", ";\n  }\n"])), function (_ref2) {
  var isDisabled = _ref2.isDisabled;
  return isDisabled ? '0.5' : '1';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.labelColor;
});

exports.SwitchBaseContainer = SwitchBaseContainer;